import React from "react";
import { Menu } from "lucide-react";

import { COMPANY_INFO } from "../../data/mock";

const AdminHeader = ({
  title = "Admin Panel",
  subtitle,
  onToggleSidebar,
  actions,
}) => {
  return (
    <header className="h-16 bg-white/90 backdrop-blur border-b border-gray-200 flex items-center gap-4 px-6 sticky top-0 z-10">
      <button
        onClick={onToggleSidebar}
        className="p-2 rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors"
        aria-label="Toggle sidebar"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div className="min-w-0">
        <h1 className="text-lg font-semibold text-gray-900 leading-tight truncate">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs text-gray-500 hidden sm:block truncate">
            {subtitle}
          </p>
        )}
      </div>

      <div className="ml-auto flex items-center gap-3">
        {actions || (
          <span className="text-sm text-gray-500 hidden sm:block">
            {COMPANY_INFO.name}
          </span>
        )}
      </div>
    </header>
  );
};

export default AdminHeader;
